module.exports = __webpack_public_path__ + "static/discussionapp1-a5badc80f1a583825b24c742eb8af215.png";